<template>
  <div class="overview" ref="overview">
    <div class="header">
      <div class="logo" v-if="showFull">
        <!-- <img src="../assets/images/logo.png"/> -->
      </div>
      <div class="close-img">
        <div class="fullscree" v-if="showFull" @click="closeImg">
          <img src="../assets/images/temp/reduce.png" width="30px" />
        </div>
        <div class="quit" v-if="showQuit" @click="openImg">
          <img src="../assets/images/quanping.png" width="30px" />
          <!-- <p>全屏</p> -->
        </div>
      </div>
    </div>
    <div class="content">
      <!--左边开始-->
      <div class="left" ref="left">
        <div class="left-top border-bg">
          <div class="bg-top-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-top-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <!--<h5>城市资源</h5>
          <div>
             <table>
              <tr>
                <td>
                  <div class='icon'>
                    <i class='iconfont icon-tingchechang'></i>
                  </div>
                  <div>
                    <p class='info-num'>{{allDatas.parkSum}}</p>
                    <p class='info-message'>车场总数</p>
                  </div>
                </td>
                <td>
                  <div class='icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>{{allDatas.spaceAnalyze.spaceSum}}</p>
                    <p class='info-message'>泊位总数</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class='icon'>
                    <i class='iconfont icon-chongdianqi'></i>
                  </div>
                  <div>
                    <p class='info-num'>0</p>
                    <p class='info-message'>充电桩数量</p>
                  </div>
                </td>
                <td>
                  <div class='icon'>
                    <i class='iconfont icon-jiantouarrow503'></i>
                  </div>
                  <div>
                    <p class='info-num'>0</p>
                    <p class='info-message'>诱导屏总数</p>
                  </div>
                </td>
              </tr>
            </table>
            <div  id="myChart" style="width:100%;height:130px"></div> 
          </div>-->
          <h5>停车场概况</h5>
          <table>
            <tr>
              <td>
               
                <div class="icon square-icon">
                  <i class="iconfont icon-parking-line"></i>
                </div>
                <div>
                  <p class="info-num">{{allParkingDatas.onsiteNum}}</p>
                  <p class="info-message">室內停车场</p>
                </div>
              </td>
              <td>
                <div class="icon square-icon">
                  <i class="iconfont icon-parking-line"></i>
                </div>
                <div>
                  <p class="info-num">{{allParkingDatas.roadNum}}</p>
                  <p class="info-message">停车道路</p>
                </div>
              </td>
            </tr>
            <tr>
              <!-- <td>
                <div class="icon">
                  <i class="iconfont icon-parking-line"></i>
                </div>
                <div>
                  <p class="info-num">{{allDatas.parkSum}}</p>
                  <p class="info-message">车场总数</p>
                </div>
              </td>-->
              <td>
                <div class="icon">
                  <i class="iconfont icon-parking-line"></i>
                </div>
                <div>
                  <p class="info-num">{{allParkingDatas.roadSpaceNum}}</p>
                  <p class="info-message">泊位总数</p>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="left-middle border-bg">
          <div class="bg-top-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-top-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <h5>用户概况</h5>
          <table>
            <tr>
              <td>
                <div class="icon">
                  <!-- <i class='iconfont icon-chongdianqi'></i> -->
                  <img src="../assets/images/overview/u1112.png" />
                </div>
                <div>
                  <p class="info-num">{{allParkingDatas.userNum}}</p>
                  <p class="info-message">注册用户数</p>
                </div>
              </td>
              <td>
                <div class="icon">
                  <!-- <i class='iconfont icon-tingchechang'></i> -->
                  <img src="../assets/images/overview/u1454.png" />
                </div>
                <div>
                  <p class="info-num">{{allParkingDatas.todayNum}}</p>
                  <p class="info-message">今日注册数</p>
                </div>
              </td>
              <!-- <td>
                <div class="icon">
                
                  <img src="../assets/images/overview/u1454.png" />
                </div>
                <div>
                  <p class="info-num">1,780,164</p>
                  <p class="info-message">今日活跃数</p>
                </div>
              </td>-->
            </tr>
            <tr>
              <td>
                <div class="icon">
                  <!-- <i class='iconfont icon-jiantouarrow503'></i> -->
                  <img src="../assets/images/overview/u1112.png" />
                </div>
                <div>
                  <p class="info-num">{{allParkingDatas.hasPlateNum}}</p>
                  <p class="info-message">绑定车牌数</p>
                </div>
              </td>
              <td>
                <div class="icon">
                  <!-- <i class='iconfont icon-chongdianqi'></i> -->
                  <img src="../assets/images/overview/u1110.png" />
                </div>
                <div>
                  <p class="info-num">{{allParkingDatas.payPlateNum}}</p>
                  <p class="info-message">支付用户数</p>
                </div>
              </td>
            </tr>
            <tr>
              <!-- <td>
                <div class="icon">
                 
                  <img src="../assets/images/overview/u1110.png" />
                </div>
                <div>
                  <p class="info-num">3,362,199</p>
                  <p class="info-message">30天活跃数</p>
                </div>
              </td>-->
            </tr>
            <!-- <tr>
              <td>
                <div class="icon">
                
                  <img src="../assets/images/overview/u1237.png" />
                </div>
                <div>
                  <p class="info-num">56.23%</p>
                  <p class="info-message">线下用户转化率</p>
                </div>
              </td>
              <td>
                <div class="icon">
              
                  <img src="../assets/images/overview/u1237.png" />
                </div>
                <div>
                  <p class="info-num">24.34%</p>
                  <p class="info-message">支付用户转化率</p>
                </div>
              </td>
            </tr>-->
          </table>
        </div>
        <div class="left-bottom border-bg">
          <div class="bg-top-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-top-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="user-habits">
            <h5>
              <div>
                <!-- 用户习惯- -->
                <!-- <span v-show="show==='0'">停车时长分布</span> -->
                <span>支付方式分布</span>
                <!-- <span v-show="show==='1'">支付方式分布</span> -->
              </div>
              <!-- <div class="switch">
                <span :class="{ 'switchColor':show==='0'}"></span>
                <span :class="{ 'switchColor':show==='1'}"></span>
              </div>-->
            </h5>
            <!-- <h5>
              <div>
                用户习惯-
                <span v-show="show==='0'">停车时长分布</span>
                <span v-show="show==='1'">支付方式分布</span>
              </div>
              <div class="switch">
                <span :class="{ 'switchColor':show==='0'}"></span>
                <span :class="{ 'switchColor':show==='1'}"></span>
              </div>
            </h5>-->
          </div>
          <template>
            <ul class="parkingHours" key="0">
              <!-- <ul class="parkingHours" v-show="show==='0'" key="0"> -->
              <!-- <li v-for="item in parkingHoursData" :key="item.name">
                <span>{{item.name}}</span>
                <span class="parkingHoursChart">
                  <canvas width="200" height="20" :id="item.name"></canvas>
                </span>
              </li>
              </ul>-->
              <!-- <ul class="parkingHours" v-show="show==='1'" key="1"> -->
              <li v-for="item in payTypeData" :key="item.name">
                <span>{{item.name}}</span>
                <span class="parkingHoursChart">
                  <canvas width="200" height="20" :id="item.name"></canvas>
                </span>
                <span>{{item.value}}</span>
              </li>
            </ul>
          </template>
        </div>
      </div>
      <!--左边结束-->
      <!--中间开始-->
      <div class="middle" ref="middle">
        <div class="middle-top">
          <div class="homemap" id="map"></div>
        </div>
        <div class="middle-bottom border-bg" ref="middleBottom">
          <div class="bg-top-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-top-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="total-income">
            <div class="total-incom-top">
              <div class="total-incom-top-message">今年总收入(元)</div>
              <div class="total-incom-top-data">
                <div class="total-incom-top-data-left">
                  <p>{{allMoneyDatas.todayMoney}}</p>
                  <p>今日收入(元)</p>
                </div>
                <div class="total-incom-top-data-middle" ref="totalMoneyDom">
                  <!-- <span>8</span>
                    <span>2</span>
                    <span>,</span>
                    <span>6</span>
                    <span>4</span>
                    <span>6</span>
                    <span>,</span>
                    <span>3</span>
                    <span>0</span>
                  <span>0</span>-->
                </div>
                <div class="total-incom-top-data-right">
                  <p>{{allMoneyDatas.yesterdayMoney}}</p>
                  <p>昨日收入(元)</p>
                </div>
              </div>
            </div>
            <div class="total-income-bottom">
              <div class="total-income-bottom-liebiao">
                <table>
                  <tr>
                    <td>
                      <div class="icon icon-money">
                        应
                        <!-- <i class='iconfont icon-tingchechang'></i> -->
                        <!-- <img src="../assets/images/overview/u1454.png" /> -->
                      </div>
                      <div>
                        <p class="info-num">{{allMoneyDatas.receivable}}</p>
                        <p class="info-message">应收金额</p>
                      </div>
                    </td>
                    <td>
                      <div class="icon icon-money">
                        实
                        <!-- <i class='iconfont icon-parking-line'></i> -->
                        <!-- <img src="../assets/images/overview/u1454.png" /> -->
                      </div>
                      <div>
                        <p class="info-num">{{allMoneyDatas.realMoney}}</p>
                        <p class="info-message">实收金额</p>
                      </div>
                    </td>
                    <td>
                      <div class="icon icon-money">
                        追
                        <!-- <i class='iconfont icon-chongdianqi'></i> -->
                        <!-- <img src="../assets/images/overview/u1112.png" /> -->
                      </div>
                      <div>
                        <p class="info-num">{{allMoneyDatas.arrearsMoney}}</p>
                        <p class="info-message">追缴金额</p>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="icon icon-money">
                        欠
                        <!-- <i class='iconfont icon-chongdianqi'></i> -->
                        <!-- <img src="../assets/images/overview/u1112.png" /> -->
                      </div>
                      <div>
                        <p class="info-num">{{allMoneyDatas.unpayMoney}}</p>
                        <p class="info-message">欠费金额</p>
                      </div>
                    </td>
                    <!-- <td>
                      <div class="icon icon-money">
                        逃
                     
                      </div>
                      <div>
                        <p class="info-num">{{allMoneyDatas.today}}</p>
                        <p class="info-message">逃费金额</p>
                      </div>
                    </td>-->
                    <!-- <td>
                      <div class="icon">
                     
                        <img src="../assets/images/overview/u1112.png" />
                      </div>
                      <div>
                        <p class="info-num">62,189</p>
                        <p class="info-message">绑定车牌总数</p>
                      </div>
                    </td>-->
                  </tr>
                </table>
              </div>
              <!-- <div class='classifyEquipChart'>
                 <div class='road-chart'></div>
                <div class='classifyEquipChart-bottom'>
                  <span class='battery-chart'></span>
                  <span class='jeeves-chart'></span>
                </div>
              </div>-->
              <div id="classifyEquipChart" style="width:40%;height:auto;min-height:150px"></div>
            </div>
          </div>
        </div>
      </div>
      <!--中间结束-->
      <!--右边开始-->
      <div class="right" ref="right">
        <div class="right-middle2 border-bg">
          <div class="bg-top-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-top-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <h5>设备概况</h5>
          <ul class="parkingHours equip">
            <li v-for="item in equipData" :key="item.name">
              <span>{{item.name}}</span>
              <span class="parkingHoursChart">
                <canvas width="200" height="20" :id="item.name"></canvas>
              </span>
              <span>{{item.value}}</span>
            </li>
          </ul>
        </div>

        <!--<div class='right-top border-bg'>
           <div class='bg-top-left-x'>
            <img src='../assets/images/overview/u1288.png'/>
          </div>
          <div class='bg-top-left-y'>
             <img src='../assets/images/overview/u1286.png'/>
          </div>
          <div class='bg-top-right-x'>
            <img src='../assets/images/overview/u1288.png'/>
          </div>
          <div class='bg-top-right-y'>
             <img src='../assets/images/overview/u1286.png'/>
          </div>
          <div class='bg-bottom-left-x'>
            <img src='../assets/images/overview/u1288.png'/>
          </div>
          <div class='bg-bottom-left-y'>
            <img src='../assets/images/overview/u1286.png'/>
          </div>
          <div class='bg-bottom-right-x'>
            <img src='../assets/images/overview/u1288.png'/>
          </div>
          <div class='bg-bottom-right-y'>
            <img src='../assets/images/overview/u1286.png'/>
          </div>
           <h5>停车场概况</h5>
          <table>
              <tr>
                <td>
                  <div class='icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>130</p>
                    <p class='info-message'>免费停车场(个)</p>
                  </div>
                </td>
                <td>
                  <div class='icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>3,200</p>
                    <p class='info-message'>收费停车场(个)</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class='icon square-icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>4,154</p>
                    <p class='info-message'>路外停车场(个)</p>
                  </div>
                </td>
                <td>
                  <div class='icon square-icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>5,456</p>
                    <p class='info-message'>占道停车场(个)</p>
                  </div>
                </td>
              </tr>
            </table> 
        </div>-->
        <div class="right-middle1 border-bg">
          <div class="bg-top-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-top-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <h5>泊位概况</h5>
          <div class="total-space">
            <span>
              <img src="../assets/images/overview/u1155.png" />
            </span>
            <span class="total-space-info-bg">
              <span class="total-space-info-message">泊位总数(个)：{{allParkingDatas.roadSpaceNum}}</span>
            </span>
            <span>
              <img src="../assets/images/overview/u1155.png" />
            </span>
          </div>
          <div id="spaceChart" style="width:90%;height:130px"></div>
          <!-- <table>
            <tr>
              <td>
                <div class="icon">
                  <img src="../assets/images/overview/u1478.png" />
                </div>
                <div>
                  <p class="info-num">30.19</p>
                  <p class="info-message">泊位周转频次</p>
                </div>
              </td>
              <td>
                <div class="icon">
                  <img src="../assets/images/overview/u1478.png" />
                </div>
                <div>
                  <p class="info-num">50,18</p>
                  <p class="info-message">泊位利用率</p>
                </div>
              </td>
            </tr>
          </table>-->
        </div>

        <div class="right-top border-bg">
          <div class="bg-top-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-top-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="user-habits">
            <h5>
              <div>
                <!-- 用户习惯- -->
                <!-- <span v-show="show==='0'">停车时长分布</span> -->
                <!-- <span v-show="show==='1'">支付方式分布</span> -->
                <span>停车时长分布</span>
              </div>
              <!-- <div class="switch">
                <span :class="{ 'switchColor':show==='0'}"></span>
                <span :class="{ 'switchColor':show==='1'}"></span>
              </div>-->
            </h5>
          </div>
          <template>
            <!-- <ul class="parkingHours" v-show="show==='0'" key="0"> -->
            <ul class="parkingHours" key="1">
              <li v-for="item in parkingHoursData" :key="item.name">
                <span>{{item.name}}</span>
                <span class="parkingHoursChart">
                  <canvas width="200" height="20" :id="item.name"></canvas>
                </span>
              </li>
            </ul>
            <!-- <ul class="parkingHours" v-show="show==='1'" key="1">
          
              <li v-for="item in payTypeData" :key="item.name">
                <span>{{item.name}}</span>
                <span class="parkingHoursChart">
                  <canvas width="200" height="20" :id="item.name"></canvas>
                </span>
              </li>
            </ul>-->
          </template>
        </div>
        <!-- <div class='right-bottom border-bg' ref='rightBottom'>
           <div class='bg-top-left-x'>
            <img src='../assets/images/overview/u1288.png'/>
          </div>
          <div class='bg-top-left-y'>
             <img src='../assets/images/overview/u1286.png'/>
          </div>
          <div class='bg-top-right-x'>
            <img src='../assets/images/overview/u1288.png'/>
          </div>
          <div class='bg-top-right-y'>
             <img src='../assets/images/overview/u1286.png'/>
          </div>
          <div class='bg-bottom-left-x'>
            <img src='../assets/images/overview/u1288.png'/>
          </div>
          <div class='bg-bottom-left-y'>
            <img src='../assets/images/overview/u1286.png'/>
          </div>
          <div class='bg-bottom-right-x'>
            <img src='../assets/images/overview/u1288.png'/>
          </div>
          <div class='bg-bottom-right-y'>
            <img src='../assets/images/overview/u1286.png'/>
          </div>
          <h5>运维工单</h5>
          <table>
              <tr>
                <td>
                  <div class='icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>100</p>
                    <p class='info-message'>未分配工单</p>
                  </div>
                </td>
                <td>
                  <div class='icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>20</p>
                    <p class='info-message'>未接收工单</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class='icon square-icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>3,000</p>
                    <p class='info-message'>处理中工单</p>
                  </div>
                </td>
                <td>
                  <div class='icon square-icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>552,109</p>
                    <p class='info-message'>已处理工单</p>
                  </div>
                </td>
              </tr>
            </table>
        </div>-->
      </div>
      <!--右边结束-->
    </div>
  </div>
</template>
<script>
import { echarts } from "../utils/initEchart";
import MainMenu from "../page/commons/menu/mainMenu/mainMenu";
import {
  waitForTiandituAPI,
  createTiandituMap,
  setMapEvent,
  createMarker,
  addMarkerToMap
} from "@/utils/tianditu";
import {
  createTag,
  mapPark,
  homeMoneyDatas,
  homeDatas,
  homeParkingDatas
} from "../api/url";
export default {
  data() {
    return {
      allDatas: {
        parkSum: "",
        spaceAnalyze: {
          spaceSum: ""
        },
        bodyWidth: "",
        today: "",
        yesterday: "",
        real_money: ""
      },
      allParkingDatas: {
        roadNum: "", //路边道路数量
        onsiteNum: "", //室内车场数量
        roadSpaceNum: "", //路边泊位总数
        usedSpaceNum: "", //路边泊位使用数量
        freeSpaceNum: "", //路边泊位空闲数量
        errorSpaceNum: "", //路边泊位故障数量
        devNum: "", //设备总数
        usedDevNum: "", //在线设备
        errorDevNum: "", //故障设备
        todayNum: "", //今日注册数
        userNum: "", //注册用户数
        hasPlateNum: "", //绑定车牌数
        payPlateNum: "", //支付车牌数
        hours_0_1: "", // 0-1小时
        hours_1_3: "", //1-3小时
        hours_3_6: "", //3-6小时
        hours_6: "" //6小时以上
      },
      allMoneyDatas: {
        todayMoney: "", //今日收入(元)
        yesterdayMoney: "", //昨日收入(元)
        yearMoney: "", //今年总收入

        receivable: "", //应收金额

        realMoney: "", //实收金额

        arrearsMoney: "", //追缴金额
        unpayMoney: "" //欠费金额
      },
      outerDom: "",
      totalMoney: [],
      map: "",
      // echarts 实例引用
      spaceChartInstance: null,
      classifyEquipChartInstance: null,
      showState0: true,
      showState1: false,
      showFull: true,
      showQuit: false,
      //.show==0:true,
      // showPayType:false,
      show: "0",
      routePath: "",
      parkingDatasTimer: "",
      moneyDatasTimer: "",
      parkingHoursData: [
        // { name: "0-1小时", value: "100" },
        // { name: "0.5-1小时", value: "50" },
        // { name: "1-3小时", value: "80" },
        // { name: "4-6小时", value: "100" },
        // { name: "6小时以上", value: "150" }
      ],
      payTypeData: [
        // { name: "微信", value: "100" },
        // { name: "支付宝", value: "50" },
        // { name: "城市通卡", value: "80" },
        // { name: "其它", value: "100" },
        // { name: "现金", value: "150" }
      ],
      equipData: [
        // { name: "设备总数", value: "100" },
        // { name: "在线设备", value: "50" },
        // { name: "故障设备", value: "80" },
        // { name: "离线设备", value: "100" }
      ],
      // classifyEquipChartData: {
      //   nodes: [
      //     {
      //       color: "#FFCC00",
      //       label: "道路",
      //       attributes: {},
      //       // "y":5,
      //       // "x":5,
      //       id: "joosex-namespace-depended",
      //       size: 80
      //     },
      //     {
      //       color: "#00CC33",
      //       label: "停车场",
      //       attributes: {},
      //       // "y":6,
      //       // "x":6,
      //       id: "sourcemint-util-js",
      //       size: 120
      //     }
      //     // {
      //     //   color: "#33CCFF",
      //     //   label: "充电",
      //     //   attributes: {},
      //     //   // "y":6,
      //     //   // "x":6,
      //     //   id: "spmrc",
      //     //   size: 80
      //     // }
      //   ]
      // },
      classifyEquipChart: {
        color: ["#00CC33", "#F7B82D", "#3ED9FF"],
        series: [
          {
            // name: "姓名",
            type: "pie",
            radius: "55%",
            label: {
              normal: {
                show: true,
                position: "inner",
                formatter: "{b} \n{d}%"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "14",
                  fontWeight: "bold"
                }
              }
            },
            center: ["50%", "50%"],
            data: []
          }
        ]
      },

      spaceChart: {
        tooltip: {
            trigger: 'item',
            formatter: "{b}: {c} ({d}%)"
        },
        grid: {
          // top:30,
          // left:0,
          // right:100,
          // bottom:30
        },
        legend: {
          top: "middle",
          right: "50px",
          itemGap: 20,
          orient: "vertical",
          x: "right",
          data: ["已用", "空闲", "故障"],
          textStyle: {
            color: "#34B5E0"
          }
        },
        series: [
          {
            // name:'访问来源',
            type: "pie",
            color: ["#0099FF", "#00CC33", "#FFCC00"],
            center: ["30%", "50%"],
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "18",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              // { value: 62, name: "已用" },
              // { value: 22, name: "空闲" },
              // { value: 16, name: "故障" }
            ]
          }
        ]
      }
    };
  },
  methods: {
    closeImg() {
      this.$router.push("/main/home");
    },
    openImg() {
      this.$router.push("/main/cityFacts/all");
    },
    parkingHoursChart() {
      var sum = this.parkingHoursData.reduce(function(prev, cur) {
        return prev + cur.value;
      }, 0);
      var parkingHoursChartWidth = this.bodyWidth * 0.25 * 0.7;
      for (let item of this.parkingHoursData) {
        var canvas = document.getElementById(item.name);

        canvas.width = (item.value / sum) * parkingHoursChartWidth;
        canvas.style.borderRadius = "0 10px 10px 0";
        var context = canvas.getContext("2d");
        context.fillStyle = "#00CC33";
        context.fillRect(0, 0, item.value, 20);
      }
    },
    payTypeChart() {
      var sum = this.payTypeData.reduce(function(prev, cur) {
        return prev + cur.value;
      }, 0);
      var payTypeChartWidth = this.bodyWidth * 0.25 * 0.7;
      let color = ["#00CC33", "#FFBA33", "#1AD0FE", "#A31AFE", "#1AFE85"];
      let i = 0;
      for (let item of this.payTypeData) {
        var canvas = document.getElementById(item.name);
        canvas.width = (item.value / sum) * payTypeChartWidth;
        canvas.style.borderRadius = "0 10px 10px 0";
        var context = canvas.getContext("2d");
        context.fillStyle = color[i];
        context.fillRect(0, 0, item.value, 20);
        i++;
      }
    },
    equipChart() {
      var sum = this.equipData.reduce(function(prev, cur) {
        return prev + cur.value;
      }, 0);
      var equipChartWidth = this.bodyWidth * 0.25 * 0.4;
      let color = ["#00CC33", "#FFBA33", "#1AD0FE", "#A31AFE", "#1AFE85"];
      let i = 0;
      for (let item of this.equipData) {
        var canvas = document.getElementById(item.name);
        canvas.width = (item.value / sum) * equipChartWidth;
        canvas.style.borderRadius = "10px";
        var context = canvas.getContext("2d");
        context.fillStyle = color[i];
        context.fillRect(0, 0, item.value, 20);
        i++;
      }
    },
    // switchParkingHoursAndPayType() {
    //   var _this = this;
    //   setInterval(function() {
    //     if (_this.show === "0") {
    //       _this.show = "1";
    //     } else {
    //       _this.show = "0";
    //     }
    //   }, 1500);
    // },
    // 等待天地图API加载完成
    async createMap() {
      // 导入天地图工具类
      const {
        waitForTiandituAPI,
        createTiandituMap,
        setMapEvent,
        createMarker,
        addMarkerToMap
      } = await import('@/utils/tianditu');
      
      // 等待API加载
      await waitForTiandituAPI();
      
      // 创建地图 - 初始位置定位到保康县
      const map = createTiandituMap("map", {
        centerLng: 111.26744121202825, // 保康县经度
        centerLat: 31.883847150262206, // 保康县纬度
        zoom: 12 // 调整缩放级别以更好地显示保康县
      });

      if (!map) {
        console.error('地图创建失败');
        return;
      }

      // 保存地图实例到 this.map
      this.map = map;
      
      // 将地图实例保存到 window，方便调试
      window.mapInstance = map;

      // 设置地图事件
      setMapEvent(map);
      
      // 获取停车场数据并添加标记点
      this.$get(mapPark(), {}).then(data => {
        if (data.status != 200) return;
        const rows = data.data;

        rows.forEach(row => {
          const marker = createMarker(row.pointLng, row.pointLat, {
            iconUrl: require("@/assets/images/mark.png"),
            iconSizeWidth: 25,
            iconSizeHeight: 35,
            iconAnchorX: 10,
            iconAnchorY: 25
          });

          if (marker) {
            addMarkerToMap(map, marker);
            createTag(map, marker, row);
          }
        });
      });

      //腾讯地图
      // 创建地图
      // var map = new qq.maps.Map(document.getElementById("map"), {
      //   center: new qq.maps.LatLng(39.916527, 116.397128), // 地图的中心地理坐标
      //   zoom: 8, // 地图缩放级别
      //   mapStyleId: "style2" // 该key绑定的style1对应于经典地图样式，若未绑定将弹出无权限提示窗
      // });
    },
    getAllDatas() {
      this.$get(homeDatas()).then(data => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        this.allDatas = data.data;
        var m = parseFloat(data.data.yearMoney).toFixed(0);

        this.totalMoney = m
          .toString()
          .replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,")
          .split("");
        var contentHtml = "";
        for (let item of this.totalMoney) {
          contentHtml +=
            '<span style="margin-right:3px;display:inline-block;width:40px;height:70px;background:#002F55;line-height:70px;text-align:center;color:#F7B82D;font-size:60px;">' +
            item +
            "</span>";
        }
        this.outerDom.innerHTML = contentHtml;
      });
    },
    getParkingDatas() {
      var _this = this;
      this.$get(homeParkingDatas()).then(data => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        var d = data.data;
        this.allParkingDatas = data.data;
       
        var tempEquip = [];
        var tempPayParkingHours = [];
        var tempSpace = [];
        for (let prop in d) {
          let item = {
            name: "",
            value: ""
          };
          switch (prop) {
            case "devNum": {
              item.name = "设备总数";
              item.value = d[prop];
              tempEquip.push(item);
              break;
            }
            case "usedDevNum": {
              item.name = "在线设备";
              item.value = d[prop];
              tempEquip.push(item);
              break;
            }
            case "errorDevNum": {
              item.name = "故障设备";
              item.value = d[prop];
              tempEquip.push(item);
              break;
            }
            case "hours_0_1": {
              item.name = "0-1小时";
              item.value = d[prop];
              tempPayParkingHours.push(item);
              break;
            }
            case "hours_1_3": {
              item.name = "1-3小时";
              item.value = d[prop];
              tempPayParkingHours.push(item);
              break;
            }
            case "hours_3_6": {
              item.name = "3-6小时";
              item.value = d[prop];
              tempPayParkingHours.push(item);
              break;
            }
            case "hours_6": {
              item.name = "6小时以上";
              item.value = d[prop];
              tempPayParkingHours.push(item);
              break;
            }
            case "usedSpaceNum": {
              item.name = "已用";
              item.value = d[prop];
              tempSpace.push(item);
              break;
            }
            case "freeSpaceNum": {
              item.name = "空闲";
              item.value = d[prop];
              tempSpace.push(item);
              break;
            }
            default: {
              break;
            }
          }
        }
        this.equipData = tempEquip;
        this.parkingHoursData = tempPayParkingHours;
        this.spaceChart.series[0].data = tempSpace;
        this.$nextTick(function() {
          //设备
          _this.equipChart();
          //停车时长分布
          _this.parkingHoursChart();
          //泊位概况
          const spaceChartDom = document.getElementById("spaceChart");
          if (spaceChartDom) {
            // 如果实例已存在，只更新数据并resize
            if (_this.spaceChartInstance) {
              _this.spaceChartInstance.setOption(_this.spaceChart);
              setTimeout(() => {
                if (_this.spaceChartInstance) {
                  _this.spaceChartInstance.resize();
                }
              }, 100);
            } else {
              // 如果实例不存在，创建新实例
              if (spaceChartDom.offsetWidth > 0 && spaceChartDom.offsetHeight > 0) {
                _this.spaceChartInstance = echarts.init(spaceChartDom);
                _this.spaceChartInstance.setOption(_this.spaceChart);
              } else {
                // 如果容器尺寸为0，延迟创建
                setTimeout(() => {
                  const dom = document.getElementById("spaceChart");
                  if (dom && dom.offsetWidth > 0 && dom.offsetHeight > 0) {
                    _this.spaceChartInstance = echarts.init(dom);
                    _this.spaceChartInstance.setOption(_this.spaceChart);
                  }
                }, 100);
              }
            }
          }
        });
      });
    },
    getMoneyDatas() {
      var _this = this;
      this.$get(homeMoneyDatas()).then(data => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        var d = data.data;
        this.allMoneyDatas = data.data;
        var tempPayType = [];
        var tempPayParkingType = [];
        var m = parseFloat(d.yearMoney).toFixed(0);
        this.totalMoney = m
          .toString()
          .replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,")
          .split("");
        var contentHtml = "";
        for (let item of this.totalMoney) {
          contentHtml +=
            '<span style="margin-right:3px;display:inline-block;width:40px;height:70px;background:#002F55;line-height:70px;text-align:center;color:#F7B82D;font-size:60px;">' +
            item +
            "</span>";
        }
        this.outerDom.innerHTML = contentHtml;
        var tempPayParkingHours = [];
        var tempSpace = [];
        for (let prop in d) {
          let item = {
            name: "",
            value: ""
          };
          switch (prop) {
            case "wechat": {
              item.name = "微信";
              item.value = d[prop];
              tempPayType.push(item);
              break;
            }
            case "alipay": {
              item.name = "支付宝";
              item.value = d[prop];
              tempPayType.push(item);
              break;
            }
            case "other": {
              item.name = "其它";
              item.value = d[prop];
              tempPayType.push(item);
              break;
            }
            case "cash": {
              item.name = " 现金";
              item.value = d[prop];
              tempPayType.push(item);
              break;
            }
            case "onsiteRate": {
              item.name = "停车场";
              item.value = d[prop];
              tempPayParkingType.push(item);
              break;
            }
            case "roadRate": {
              item.name = "路边";
              item.value = d[prop];
              tempPayParkingType.push(item);
              break;
            }
            default: {
              break;
            }
          }
        }
        this.classifyEquipChart.series[0].data = tempPayParkingType;
        this.payTypeData = tempPayType;
        this.$nextTick(function() {
          //设备
          _this.payTypeChart();
          const classifyEquipChartDom = document.getElementById("classifyEquipChart");
          if (classifyEquipChartDom) {
            // 确保容器使用百分比高度自适应
            classifyEquipChartDom.style.height = '100%';
            classifyEquipChartDom.style.minHeight = '0';
            
            // 如果实例已存在，只更新数据并resize
            if (_this.classifyEquipChartInstance) {
              _this.classifyEquipChartInstance.setOption(_this.classifyEquipChart);
              setTimeout(() => {
                if (_this.classifyEquipChartInstance) {
                  _this.classifyEquipChartInstance.resize();
                }
              }, 100);
            } else {
              // 如果实例不存在，创建新实例
              // 延迟创建，确保容器尺寸已更新
              setTimeout(() => {
                const dom = document.getElementById("classifyEquipChart");
                if (dom) {
                  // 确保容器使用百分比高度自适应
                  dom.style.height = '100%';
                  dom.style.minHeight = '0';
                  const parentHeight = dom.parentElement ? dom.parentElement.offsetHeight : 0;
                  
                  if (dom.offsetWidth > 0 && (dom.offsetHeight > 0 || parentHeight > 0)) {
                    _this.classifyEquipChartInstance = echarts.init(dom);
                    _this.classifyEquipChartInstance.setOption(_this.classifyEquipChart);
                  } else {
                    // 如果容器尺寸仍为0，继续重试
                    let retryCount = 0;
                    const maxRetries = 10;
                    const checkAndCreate = () => {
                      const retryDom = document.getElementById("classifyEquipChart");
                      if (retryDom) {
                        retryDom.style.height = '100%';
                        retryDom.style.minHeight = '0';
                        const parentHeight = retryDom.parentElement ? retryDom.parentElement.offsetHeight : 0;
                        if (retryDom.offsetWidth > 0 && (retryDom.offsetHeight > 0 || parentHeight > 0)) {
                          _this.classifyEquipChartInstance = echarts.init(retryDom);
                          _this.classifyEquipChartInstance.setOption(_this.classifyEquipChart);
                        } else if (retryCount < maxRetries) {
                          retryCount++;
                          setTimeout(checkAndCreate, 100);
                        }
                      }
                    };
                    setTimeout(checkAndCreate, 100);
                  }
                }
              }, 100);
            }
          }
        });
      });
    },
    //10s定时刷新设备状况和泊位状况数据
    timedRefreshParkingDatas() {
    
      // let _this = this;
      this.getParkingDatas();
      // this.parkingDatasTimer = setTimeout(
      //   _this.timedRefreshParkingDatas,
      //   10000
      // );
    },
    //3s定时刷新收费状况数据
    timedRefreshMoneyDatas() {
     
      // let _this = this;
      this.getMoneyDatas();
      // this.moneyDatasTimer = setTimeout(_this.timedRefreshMoneyDatas, 3000);
    }
  },
  computed: {},
  components: {
    MainMenu
  },
  created: function() {
    document.getElementById("appLoading").style.display = "none";
    this.routePath = this.$route.path;
  },
  mounted: function() {
    this.timedRefreshParkingDatas();
    this.timedRefreshMoneyDatas();
    this.outerDom = this.$refs.totalMoneyDom;
    this.bodyWidth = document.body.offsetWidth;
    
    // 初始化 classifyEquipChart（延迟创建，确保容器尺寸已更新）
    this.$nextTick(() => {
      setTimeout(() => {
        const classifyEquipChartDom = document.getElementById("classifyEquipChart");
        if (classifyEquipChartDom) {
          // 确保容器使用百分比高度自适应
          classifyEquipChartDom.style.height = '100%';
          classifyEquipChartDom.style.minHeight = '0';
          const parentHeight = classifyEquipChartDom.parentElement ? classifyEquipChartDom.parentElement.offsetHeight : 0;
          
          if (classifyEquipChartDom.offsetWidth > 0 && (classifyEquipChartDom.offsetHeight > 0 || parentHeight > 0)) {
            this.classifyEquipChartInstance = echarts.init(classifyEquipChartDom);
            this.classifyEquipChartInstance.setOption(this.classifyEquipChart);
          } else {
            // 如果容器尺寸为0，延迟创建（增加重试机制）
            let retryCount = 0;
            const maxRetries = 10;
            const checkAndCreate = () => {
              const dom = document.getElementById("classifyEquipChart");
              if (dom) {
                // 确保容器使用百分比高度自适应
                dom.style.height = '100%';
                dom.style.minHeight = '0';
                const parentHeight = dom.parentElement ? dom.parentElement.offsetHeight : 0;
                
                if (dom.offsetWidth > 0 && (dom.offsetHeight > 0 || parentHeight > 0)) {
                  this.classifyEquipChartInstance = echarts.init(dom);
                  this.classifyEquipChartInstance.setOption(this.classifyEquipChart);
                } else if (retryCount < maxRetries) {
                  retryCount++;
                  setTimeout(checkAndCreate, 100);
                } else {
                  console.warn('classifyEquipChart 容器尺寸始终为0，无法创建图表');
                }
              }
            };
            setTimeout(checkAndCreate, 100);
          }
        }
      }, 100);
    });
    
    this.parkingHoursChart();
    this.payTypeChart();
    // 等待天地图API加载完成后再创建地图
    this.createMap();
    // this.switchParkingHoursAndPayType();
    // 初始化时检查路由，如果是全屏模式，应用相应的样式
    this.$nextTick(() => {
      if (this.routePath == "/main/cityFacts/all") {
        this.showFull = true;
        this.showQuit = false;
        if (this.$refs.overview) {
          this.$refs.overview.style.height = "100vh";
          this.$refs.overview.style.width = "100vw";
          this.$refs.overview.style.overflow = "hidden";
          this.$refs.overview.style["min-width"] = "100%";
          this.$refs.overview.style["max-width"] = "100%";
          this.$refs.overview.classList.add("overview-fullscreen");
        }
        document.body.classList.add("overview-fullscreen-body");
        document.documentElement.classList.add("overview-fullscreen-html");
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
        document.body.style.height = "100vh";
        document.documentElement.style.height = "100vh";
        document.body.style.width = "100vw";
        document.documentElement.style.width = "100vw";
        document.body.style.maxWidth = "100vw";
        document.documentElement.style.maxWidth = "100vw";
      } else {
        this.showFull = false;
        this.showQuit = true;
      }
    });
  },
  destroyed: function() {
    clearTimeout(this.parkingDatasTimer);
    clearTimeout(this.moneyDatasTimer);
  },
  watch: {
    routePath: function(newVal, oldVal) {
      const _this = this;
      
      // 保存地图状态（中心点和缩放级别）
      let savedMapCenter = null;
      let savedMapZoom = null;
      if (_this.map) {
        try {
          if (typeof _this.map.getCenter === 'function') {
            const center = _this.map.getCenter();
            if (center) {
              savedMapCenter = {
                lng: center.lng || center.getLng(),
                lat: center.lat || center.getLat()
              };
            }
          }
          if (typeof _this.map.getZoom === 'function') {
            savedMapZoom = _this.map.getZoom();
          }
        } catch (e) {
          console.warn('保存地图状态失败:', e);
        }
      }
      
      if (newVal == "/main/cityFacts/all") {
        this.showFull = true;
        this.showQuit = false;
        if (this.$refs.overview) {
          this.$refs.overview.style.height = "100vh";
          this.$refs.overview.style.width = "100vw";
          this.$refs.overview.style.overflow = "hidden";
          this.$refs.overview.style["min-width"] = "100%";
          this.$refs.overview.style["max-width"] = "100%";
          this.$refs.overview.classList.add("overview-fullscreen");
        }
        // 全屏模式下禁用 body 和 html 的滚动
        document.body.classList.add("overview-fullscreen-body");
        document.documentElement.classList.add("overview-fullscreen-html");
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
        document.body.style.height = "100vh";
        document.documentElement.style.height = "100vh";
        document.body.style.width = "100vw";
        document.documentElement.style.width = "100vw";
        document.body.style.maxWidth = "100vw";
        document.documentElement.style.maxWidth = "100vw";
      } else {
        this.showFull = false;
        this.showQuit = true;
        if (this.$refs.overview) {
          this.$refs.overview.style.height = "100vh";
          this.$refs.overview.style.width = "100%";
          this.$refs.overview.style.overflowY = "auto";
          this.$refs.overview.style.overflowX = "hidden";
          this.$refs.overview.style["padding-bottom"] = "30px";
          this.$refs.overview.classList.remove("overview-fullscreen");
        }
        // 退出全屏模式时恢复 body 和 html 的滚动
        document.body.classList.remove("overview-fullscreen-body");
        document.documentElement.classList.remove("overview-fullscreen-html");
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
        document.body.style.height = "";
        document.documentElement.style.height = "";
        document.body.style.width = "";
        document.documentElement.style.width = "";
        document.body.style.maxWidth = "";
        document.documentElement.style.maxWidth = "";
      }
      
      // 等待 DOM 更新后，重新调整图表和地图大小
      // 使用多重延迟确保容器尺寸已更新
      this.$nextTick(() => {
        // 第一层延迟：等待 DOM 更新
        setTimeout(() => {
          // 第二层延迟：等待浏览器完成重排
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              // 第三层延迟：确保容器尺寸已更新
              setTimeout(() => {
                const resizeCharts = () => {
                  // 1. 重新调整 spaceChart 大小
                  const spaceChartDom = document.getElementById("spaceChart");
                  if (spaceChartDom) {
                    const width = spaceChartDom.offsetWidth;
                    const height = spaceChartDom.offsetHeight;
                    if (width > 0 && height > 0) {
                      if (_this.spaceChartInstance) {
                        try {
                          // 确保实例没有被销毁
                          if (!_this.spaceChartInstance.isDisposed && typeof _this.spaceChartInstance.resize === 'function') {
                            _this.spaceChartInstance.resize();
                          } else {
                            // 如果实例被销毁，重新创建
                            if (_this.spaceChart && _this.spaceChart.series && _this.spaceChart.series[0] && _this.spaceChart.series[0].data) {
                              _this.spaceChartInstance = echarts.init(spaceChartDom);
                              _this.spaceChartInstance.setOption(_this.spaceChart);
                            }
                          }
                        } catch (e) {
                          console.warn('spaceChart resize 失败:', e);
                          // 如果 resize 失败，尝试重新创建
                          if (_this.spaceChart && _this.spaceChart.series && _this.spaceChart.series[0] && _this.spaceChart.series[0].data) {
                            try {
                              if (_this.spaceChartInstance && !_this.spaceChartInstance.isDisposed) {
                                _this.spaceChartInstance.dispose();
                              }
                            } catch (disposeError) {
                              // ignore
                            }
                            _this.spaceChartInstance = echarts.init(spaceChartDom);
                            _this.spaceChartInstance.setOption(_this.spaceChart);
                          }
                        }
                      } else if (_this.spaceChart && _this.spaceChart.series && _this.spaceChart.series[0] && _this.spaceChart.series[0].data) {
                        // 如果实例不存在，创建新实例
                        _this.spaceChartInstance = echarts.init(spaceChartDom);
                        _this.spaceChartInstance.setOption(_this.spaceChart);
                      }
                    }
                  }
                  
                  // 2. 重新调整 classifyEquipChart 大小
                  const classifyEquipChartDom = document.getElementById("classifyEquipChart");
                  if (classifyEquipChartDom) {
                    // 确保容器使用百分比高度自适应
                    classifyEquipChartDom.style.height = '100%';
                    classifyEquipChartDom.style.minHeight = '0';
                    const parentHeight = classifyEquipChartDom.parentElement ? classifyEquipChartDom.parentElement.offsetHeight : 0;
                    
                    const width = classifyEquipChartDom.offsetWidth;
                    const height = classifyEquipChartDom.offsetHeight || parentHeight;
                    if (width > 0 && height > 0) {
                      if (_this.classifyEquipChartInstance) {
                        try {
                          // 确保实例没有被销毁
                          if (!_this.classifyEquipChartInstance.isDisposed && typeof _this.classifyEquipChartInstance.resize === 'function') {
                            _this.classifyEquipChartInstance.resize();
                          } else {
                            // 如果实例被销毁，重新创建
                            if (_this.classifyEquipChart && _this.classifyEquipChart.series && _this.classifyEquipChart.series[0] && _this.classifyEquipChart.series[0].data) {
                              _this.classifyEquipChartInstance = echarts.init(classifyEquipChartDom);
                              _this.classifyEquipChartInstance.setOption(_this.classifyEquipChart);
                            }
                          }
                        } catch (e) {
                          console.warn('classifyEquipChart resize 失败:', e);
                          // 如果 resize 失败，尝试重新创建
                          if (_this.classifyEquipChart && _this.classifyEquipChart.series && _this.classifyEquipChart.series[0] && _this.classifyEquipChart.series[0].data) {
                            try {
                              if (_this.classifyEquipChartInstance && !_this.classifyEquipChartInstance.isDisposed) {
                                _this.classifyEquipChartInstance.dispose();
                              }
                            } catch (disposeError) {
                              // ignore
                            }
                            _this.classifyEquipChartInstance = echarts.init(classifyEquipChartDom);
                            _this.classifyEquipChartInstance.setOption(_this.classifyEquipChart);
                          }
                        }
                      } else if (_this.classifyEquipChart && _this.classifyEquipChart.series && _this.classifyEquipChart.series[0] && _this.classifyEquipChart.series[0].data) {
                        // 如果实例不存在，创建新实例
                        _this.classifyEquipChartInstance = echarts.init(classifyEquipChartDom);
                        _this.classifyEquipChartInstance.setOption(_this.classifyEquipChart);
                      }
                    } else {
                      // 如果容器尺寸仍为0，使用父容器高度并重试
                      classifyEquipChartDom.style.height = '100%';
                      classifyEquipChartDom.style.minHeight = '0';
                      setTimeout(() => {
                        const retryDom = document.getElementById("classifyEquipChart");
                        const retryParentHeight = retryDom && retryDom.parentElement ? retryDom.parentElement.offsetHeight : 0;
                        if (retryDom && retryDom.offsetWidth > 0 && (retryDom.offsetHeight > 0 || retryParentHeight > 0)) {
                          if (_this.classifyEquipChart && _this.classifyEquipChart.series && _this.classifyEquipChart.series[0] && _this.classifyEquipChart.series[0].data) {
                            if (!_this.classifyEquipChartInstance || _this.classifyEquipChartInstance.isDisposed) {
                              _this.classifyEquipChartInstance = echarts.init(retryDom);
                              _this.classifyEquipChartInstance.setOption(_this.classifyEquipChart);
                            } else {
                              _this.classifyEquipChartInstance.resize();
                            }
                          }
                        }
                      }, 200);
                    }
                  }
                  
                  // 3. 重新绘制 canvas 图表
                  _this.bodyWidth = document.body.offsetWidth;
                  _this.parkingHoursChart();
                  _this.payTypeChart();
                  _this.equipChart();
                  
                  // 4. 重新调整地图大小或重新创建地图
                  const mapDom = document.getElementById("map");
                  if (mapDom) {
                    const width = mapDom.offsetWidth;
                    const height = mapDom.offsetHeight;
                    if (width > 0 && height > 0) {
                      // 检查地图是否真的在显示（检查容器内是否有地图元素）
                      const hasMapContent = mapDom.children.length > 0 || mapDom.querySelector('.tdt-container, .tdt-map') !== null;
                      
                      // 如果地图实例不存在，或者地图容器被清空，重新创建地图
                      if (!_this.map || !hasMapContent) {
                        // 清空容器
                        mapDom.innerHTML = '';
                        // 重置地图实例
                        _this.map = null;
                        // 重新创建地图，使用保存的中心点和缩放级别
                        const mapOptions = {
                          centerLng: savedMapCenter ? savedMapCenter.lng : 111.26744121202825,
                          centerLat: savedMapCenter ? savedMapCenter.lat : 31.883847150262206,
                          zoom: savedMapZoom || 12
                        };
                        
                        // 导入并创建地图
                        import('@/utils/tianditu').then(({ waitForTiandituAPI, createTiandituMap, setMapEvent, createMarker, addMarkerToMap }) => {
                          waitForTiandituAPI().then(() => {
                            const map = createTiandituMap("map", mapOptions);
                            if (map) {
                              _this.map = map;
                              window.mapInstance = map;
                              setMapEvent(map);
                              
                              // 重新加载标记点
                              _this.$get(mapPark(), {}).then(data => {
                                if (data.status != 200) return;
                                const rows = data.data;
                                rows.forEach(row => {
                                  const marker = createMarker(row.pointLng, row.pointLat, {
                                    iconUrl: require("@/assets/images/mark.png"),
                                    iconSizeWidth: 25,
                                    iconSizeHeight: 35,
                                    iconAnchorX: 10,
                                    iconAnchorY: 25
                                  });
                                  if (marker) {
                                    addMarkerToMap(map, marker);
                                    createTag(map, marker, row);
                                  }
                                });
                              });
                            }
                          });
                        });
                      } else {
                        // 地图实例存在且容器有内容，尝试 resize
                        setTimeout(() => {
                          if (_this.map) {
                            try {
                              if (typeof _this.map.checkResize === 'function') {
                                _this.map.checkResize();
                              } else if (typeof _this.map.updateSize === 'function') {
                                _this.map.updateSize();
                              } else if (typeof _this.map.resize === 'function') {
                                _this.map.resize();
                              }
                            } catch (e) {
                              console.warn('地图 resize 失败:', e);
                              // 如果 resize 失败，重新创建地图
                              mapDom.innerHTML = '';
                              _this.map = null;
                              const mapOptions = {
                                centerLng: savedMapCenter ? savedMapCenter.lng : 111.26744121202825,
                                centerLat: savedMapCenter ? savedMapCenter.lat : 31.883847150262206,
                                zoom: savedMapZoom || 12
                              };
                              import('@/utils/tianditu').then(({ waitForTiandituAPI, createTiandituMap, setMapEvent, createMarker, addMarkerToMap }) => {
                                waitForTiandituAPI().then(() => {
                                  const map = createTiandituMap("map", mapOptions);
                                  if (map) {
                                    _this.map = map;
                                    window.mapInstance = map;
                                    setMapEvent(map);
                                    _this.$get(mapPark(), {}).then(data => {
                                      if (data.status != 200) return;
                                      const rows = data.data;
                                      rows.forEach(row => {
                                        const marker = createMarker(row.pointLng, row.pointLat, {
                                          iconUrl: require("@/assets/images/mark.png"),
                                          iconSizeWidth: 25,
                                          iconSizeHeight: 35,
                                          iconAnchorX: 10,
                                          iconAnchorY: 25
                                        });
                                        if (marker) {
                                          addMarkerToMap(map, marker);
                                          createTag(map, marker, row);
                                        }
                                      });
                                    });
                                  }
                                });
                              });
                            }
                          }
                        }, 200);
                      }
                    } else {
                      // 如果容器尺寸为0，延迟重试
                      setTimeout(() => {
                        const retryMapDom = document.getElementById("map");
                        if (retryMapDom && retryMapDom.offsetWidth > 0 && retryMapDom.offsetHeight > 0) {
                          const hasMapContent = retryMapDom.children.length > 0 || retryMapDom.querySelector('.tdt-container, .tdt-map') !== null;
                          if (!_this.map || !hasMapContent) {
                            retryMapDom.innerHTML = '';
                            _this.map = null;
                            const mapOptions = {
                              centerLng: savedMapCenter ? savedMapCenter.lng : 111.26744121202825,
                              centerLat: savedMapCenter ? savedMapCenter.lat : 31.883847150262206,
                              zoom: savedMapZoom || 12
                            };
                            import('@/utils/tianditu').then(({ waitForTiandituAPI, createTiandituMap, setMapEvent, createMarker, addMarkerToMap }) => {
                              waitForTiandituAPI().then(() => {
                                const map = createTiandituMap("map", mapOptions);
                                if (map) {
                                  _this.map = map;
                                  window.mapInstance = map;
                                  setMapEvent(map);
                                  _this.$get(mapPark(), {}).then(data => {
                                    if (data.status != 200) return;
                                    const rows = data.data;
                                    rows.forEach(row => {
                                      const marker = createMarker(row.pointLng, row.pointLat, {
                                        iconUrl: require("@/assets/images/mark.png"),
                                        iconSizeWidth: 25,
                                        iconSizeHeight: 35,
                                        iconAnchorX: 10,
                                        iconAnchorY: 25
                                      });
                                      if (marker) {
                                        addMarkerToMap(map, marker);
                                        createTag(map, marker, row);
                                      }
                                    });
                                  });
                                }
                              });
                            });
                          } else if (typeof _this.map.checkResize === 'function') {
                            _this.map.checkResize();
                          }
                        }
                      }, 300);
                    }
                  } else if (!_this.map) {
                    // 如果地图容器不存在，延迟创建
                    setTimeout(() => {
                      _this.createMap();
                    }, 500);
                  }
                };
                
                // 立即执行一次
                resizeCharts();
                
                // 增加重试机制：如果第一次检查时容器尺寸还为0，延迟重试（最多重试5次）
                let retryCount = 0;
                const maxRetries = 5;
                const retryResize = setInterval(() => {
                  resizeCharts();
                  retryCount++;
                  if (retryCount >= maxRetries) {
                    clearInterval(retryResize);
                  }
                }, 200); // 每200ms重试一次
              }, 150);
            });
          });
        }, 50);
      });
    }
  }
};
</script>
<style scoped>
.overview {
  box-sizing: border-box;
  font-size: 14px;
  /* font-size:62.5%; */
  background: #091221 !important;
  /* background: #272d39 !important; */
  height: 100vh;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 30px;
}

/* 首页在小屏幕时允许横向滚动（用于操作导航栏） */
@media (max-width: 1280px) {
  .overview {
    overflow-x: auto !important;
    min-width: 1440px;
  }
}
.overview.overview-fullscreen {
  overflow: hidden;
  padding-bottom: 0;
}
.header,
.content {
  font-size: 14px;
}
.header {
  flex-shrink: 0;
  min-height: 40px;
}
.close-img {
  cursor: pointer;
  width: 80px;
  text-align: center;
}
.close-img p {
  color: white;
}
.overview .header {
  display: flex;
  justify-content: space-between;
  padding: 5px 0 0;
  align-items: center;
}
.quit {
  opacity: 0.8;
}

.bg-top-left-x {
  position: absolute;
  left: -1px;
  top: -11px;
}
.bg-top-left-y {
  position: absolute;
  left: -1px;
  top: -4px;
}
.bg-top-right-x {
  position: absolute;
  right: -1px;
  top: -11px;
}
.bg-top-right-y {
  position: absolute;
  right: -1px;
  top: -4px;
}
.bg-bottom-right-x {
  position: absolute;
  right: -1px;
  bottom: -9px;
}
.bg-bottom-right-y {
  position: absolute;
  right: -1px;
  bottom: -3px;
}
.bg-bottom-left-x {
  position: absolute;
  left: -1px;
  bottom: -9px;
}
.bg-bottom-left-y {
  position: absolute;
  left: -1px;
  bottom: -3px;
}
table,
td,
tr {
  border: none;
}
table,
tr,
td {
  width: 100%;
}
</style>
<style scoped lang='scss'>
$border-color: #226499;
$icon-color: #33ccff;
$font-color: #0099bf;
.border-bg {
  position: relative;
  border: 1px solid $border-color;
  margin-bottom: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  > h5 {
    flex-shrink: 0;
    margin-bottom: 5px;
  }
  > .user-habits {
    flex-shrink: 0;
  }
  > table {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
    display: block;
  }
  > ul.parkingHours {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
  }
  > .total-space {
    flex-shrink: 0;
  }
  > div#spaceChart {
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
  > div#classifyEquipChart {
    flex-shrink: 0;
    overflow: hidden;
    min-height: 180px;
    height: 180px;
  }
}
h5 {
  border: 1px solid $border-color;
  width: 98%;
  margin: 5px auto;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
  color: #f7b82c;
  font-size: 16px;
  flex-shrink: 0;
  /* font-weight:bold; */
}
.icon {
  border: 1px solid $icon-color;

  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-money {
  border-radius: 50%;
}
.icon img {
  width: 25px;
}
.iconfont {
  color: $icon-color;
  font-size: 24px;
}
td {
  display: flex;
  align-items: center;
  // width:45%;
}
tr {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 5px 10px;
}
.info-num {
  color: $icon-color;
  font-weight: bold;
  font-size: 16px;
}
.info-message {
  color: $font-color;
}

.right-bottom table {
  margin-top: 3%;
}
//布局
.overview {
  width: 100%;
  height: 100vh;
  max-width: 100vw;
  padding: 0 0.5%;
  overflow-y: auto;
  overflow-x: hidden;
  color: $icon-color;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-bottom: 30px;
  &.overview-fullscreen {
    overflow: hidden;
    padding-bottom: 0;
  }
  .header {
    flex-shrink: 0;
    height: auto;
    min-height: 40px;
    max-width: 100%;
    overflow: hidden;
  }
  .content {
    width: 100%;
    max-width: 100%;
    flex: 1;
    display: flex;
    overflow: hidden;
    min-height: 0;
    gap: 5px;
    box-sizing: border-box;
    padding-bottom: 10px;
    .left {
      width: 25%;
      max-width: 25%;
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      min-width: 0;
      box-sizing: border-box;
      .left-top {
        flex: 0 0 25%;
        min-height: 0;
        overflow: hidden;
        max-width: 100%;
      }
      .left-middle {
        flex: 0 0 35%;
        min-height: 0;
        overflow: hidden;
        max-width: 100%;
      }
      .left-bottom {
        flex: 1;
        min-height: 0;
        overflow: hidden;
        max-width: 100%;
      }
    }
    .middle {
      width: 50%;
      max-width: 50%;
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      min-width: 0;
      box-sizing: border-box;
      .middle-top {
        flex: 0 0 55%;
        min-height: 0;
        overflow: hidden;
        max-width: 100%;
      }
      .middle-bottom {
        flex: 1;
        min-height: 0;
        overflow: hidden;
        max-width: 100%;
      }
    }
    .right {
      width: 25%;
      max-width: 25%;
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      min-width: 0;
      box-sizing: border-box;
      .right-top {
        flex: 0 0 35%;
        min-height: 0;
        overflow: hidden;
        max-width: 100%;
      }
      .right-middle1 {
        flex: 0 0 35%;
        min-height: 0;
        overflow: hidden;
        max-width: 100%;
      }
      .right-middle2 {
        flex: 1;
        min-height: 0;
        overflow: hidden;
        max-width: 100%;
      }
    }
  }
  &.overview-fullscreen .content {
    padding-bottom: 0;
  }
}

//停车时长分布

.parkingHours {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  li {
    display: flex;
    align-items: center;
    padding: 5px 0;
    justify-content: flex-start;
    span {
      display: inline-block;
      &:first-child {
        text-align: right;
        width: 18%;
        padding-right: 5px;
        color: $font-color;
      }
      &:last-child{
        width:5%;
        padding-left:5%;
        box-sizing: border-box;
      }
    }
  }
}

.user-habits {
  flex-shrink: 0;
  h5 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
  }
  .switch {
    span {
      background: #666666;
      display: inline-block;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      margin-right: 8px;
    }
  }
}

.switchColor {
  background: #33ccff !important;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

//停车场概况
.square-icon {
  border-radius: 0;
  width: 35px;
  height: 35px;
}
//泊位概况
.total-space-info-bg {
  display: inline-block;
  background: url("../assets/images/overview/u1151.png") center center no-repeat;
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.total-space-info-message {
  display: inline-block;
  // width:80%;
  padding: 0 10px;
  background: #272d39;
}
.total-space {
  display: flex;
  margin: 5px 10px;
  align-items: center;
  flex-shrink: 0;
}

//设备概况
.equip li span:last-child {
  text-align: left;
  width: 15%;
}
.equip li span:nth-child(2) {
  width: 50%;
}

//地图
.homemap {
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
}

//收入分析
.middle-bottom {
  margin: 5px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  > .total-income {
    flex: 1;
    min-height: 0;
  }
}
.total-income {
  padding: 5px 10px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: visible;
  box-sizing: border-box;
  > * {
    flex-shrink: 0;
  }
  > .total-incom-top {
    flex-shrink: 0;
  }
  > .total-income-bottom {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }
}
.total-incom-top-data {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.total-incom-top-data-left p,
.total-incom-top-data-right p {
  text-align: center;
}
.total-incom-top-data-left p:first-child,
.total-incom-top-data-right p:first-child {
  font-size: 24px;
  font-weight: bold;
}
.total-incom-top-message {
  text-align: center;
  padding: 10px 0;
}
// .total-incom-top-data-middle span{
//   display:inline-block;
//   width:40px;
//   height:70px;
//   background:#002F55;
//   line-height: 70px;
//   text-align: center;
//   color:#F7B82D;
//   font-size:60px;

// }
.total-incom-top-data-middle {
  display: flex;
  justify-content: space-between;
}
.total-income-bottom {
  margin-top: 5px;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  padding-bottom: 15px;
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  > * {
    flex-shrink: 0;
  }
  > div#classifyEquipChart {
    min-height: 150px;
    height: auto;
    overflow: hidden;
    flex: 0 0 40%;
    align-self: flex-start;
  }
  > .total-income-bottom-liebiao {
    flex: 0 0 60%;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
  }
}
.total-income-bottom-liebiao {
  width: 60%;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
}
.road-chart {
  position: absolute;
  left: 22%;
  top: 0;
  background: #ffcc00;
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.jeeves-chart {
  display: inline-block;
  background: #33ccff;
  width: 120px;
  height: 120px;
  border-radius: 50%;
}
.battery-chart {
  display: inline-block;
  background: #00cc33;
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
.classifyEquipChart-bottom {
  margin-top: 60px;
}
.classifyEquipChart {
  position: relative;
}

</style>
<style>
/* 隐藏天地图版权信息 */
/* 只隐藏天地图版权信息，不影响地图显示 */
#map .anchorBL,
#map .TDMap_cpyCtrl,
#map .anchorTR,
#map .anchorTL,
#map .anchorBR {
  display: none !important;
}

/* 全屏模式下确保没有滚动条 */
body:has(.overview),
html:has(.overview) {
  overflow: hidden !important;
  height: 100vh !important;
  width: 100vw !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
}

/* 首页在小屏幕时允许横向滚动（用于操作导航栏） */
@media (max-width: 1280px) {
  body:has(.overview),
  html:has(.overview) {
    overflow-x: auto !important;
  }
  
  .overview {
    overflow-x: auto !important;
    min-width: 1440px;
  }
  
  .board {
    overflow-x: auto;
  }
}

/* 兼容不支持 :has() 的浏览器 */
.overview-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw !important;
  height: 100vh !important;
  max-width: 100vw !important;
  overflow: hidden !important;
  z-index: 9999;
}

body.overview-fullscreen-body,
html.overview-fullscreen-html {
  overflow: hidden !important;
  height: 100vh !important;
  width: 100vw !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
  margin: 0;
  padding: 0;
}
</style>